import React, { Component } from "react";
import styles from "./AnnexeCategories.local.scss";
import classnames from "classnames";
import { ICONS, SvgIcon } from "../Common/Icons";
import LabelsForm from "./LabelsForm";
import { Tooltip } from "antd";
import _ from "i18n";

class ItemCategory extends Component {
  renderStandardState = () => {
    const {
      item,
      lng,
      active,
      labelsForm,
      indicators,
      selectedAccount,
      associatedAccount
    } = this.props;
    return (
      <div
        className={classnames(
          styles.item_category,
          styles.standard,
          item.enabled === 0 ? styles.disabled : "",
          active ? styles.active : ""
        )}
        onClick={() => this.props.handleToggleEnablingCategory(item.id)}
      >
        <div className={styles.item_enabled_status}>
          <img
            src={"/img/icons/white_check_mark.svg"}
            alt={""}
            className={styles.status_check}
          />
        </div>
        <span className={styles.item_label}>{item.label[lng]}</span>
        <div className={styles.associatedAccount}>
          {this.props.associatedAccount.length > 0 && (
            <span className={styles.account_label}>
              Associée à : <br />
              <span>
                {associatedAccount[0].label.fr.length <= 28
                  ? associatedAccount[0].label.fr
                  : associatedAccount[0].label.fr.slice(0, 28) + "..."}
              </span>
            </span>
          )}
        </div>

        {active && selectedAccount !== item.associatedAccount
          ? this.renderValidateUpdatesActions(item, "STANDARD")
          : this.renderStandardDefaultActions(item)}

        {active && (
          <LabelsForm
            type={"STANDARD"}
            indicators={indicators}
            selectedAccount={this.props.selectedAccount}
            onChangeSelectedAccount={this.props.onChangeSelectedAccount}
            labels={labelsForm}
            onChangeLabelFormFr={this.props.onChangeLabelFormFr}
            onChangeLabelFormEn={this.props.onChangeLabelFormEn}
            onChangeLabelFormNl={this.props.onChangeLabelFormNl}
          />
        )}
      </div>
    );
  };

  renderStandardDefaultActions = item => {
    return (
      <div
        className={classnames(styles.actions, styles.one_action)}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div>
          <span
            className={styles.action}
            onClick={() =>
              this.props.handleToggleActivatedCategoryToUpdate(
                item.id,
                item.label,
                item.associatedAccount
              )
            }
          >
            <i className={classnames("icon icon-arrow-down", styles.rotate)} />
          </span>
        </div>
      </div>
    );
  };

  //************    created Category   ************//
  renderCreatedState = () => {
    const {
      item,
      lng,
      active,
      labelsForm,
      labelsNeedsUpdate,
      indicators,
      associatedAccount,
      selectedAccount,
      backOffice
    } = this.props;
    return (
      <div
        className={classnames(
          styles.item_category,
          styles.created_state,
          item.enabled === 0 ? styles.disabled : "",
          active ? styles.active : ""
        )}
        onClick={() => this.props.handleToggleEnablingCategory(item.id)}
      >
        <div className={styles.item_enabled_status}>
          <img
            src={"/img/icons/white_check_mark.svg"}
            alt={""}
            className={styles.status_check}
          />
        </div>
        <span className={styles.item_label}>{item.label[lng]}</span>
        <div className={styles.associatedAccount}>
          {associatedAccount.length > 0 && (
            <span className={styles.account_label}>
              Associée à : <br />
              <span>
                {associatedAccount[0].label.fr.length <= 28
                  ? associatedAccount[0].label.fr
                  : associatedAccount[0].label.fr.slice(0, 28) + "..."}
              </span>
            </span>
          )}
        </div>
        {active &&
        (labelsNeedsUpdate > 0 || selectedAccount !== item.associatedAccount)
          ? this.renderValidateUpdatesActions(item, "CREATED")
          : this.renderDefaultActions(item)}
        {active && (
          <LabelsForm
            type={"CREATED"}
            indicators={indicators}
            selectedAccount={selectedAccount}
            onChangeSelectedAccount={this.props.onChangeSelectedAccount}
            labels={labelsForm}
            onChangeLabelFormFr={this.props.onChangeLabelFormFr}
            onChangeLabelFormEn={this.props.onChangeLabelFormEn}
            onChangeLabelFormNl={this.props.onChangeLabelFormNl}
            backOffice={backOffice}
          />
        )}
      </div>
    );
  };

  renderDefaultActions = item => {
    return (
      <div
        className={styles.actions}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div>
          <Tooltip placement="bottom" title={_("delete")}>
            <span
              className={styles.action}
              onClick={() => this.props.handleDeleteCategory(item.id)}
            >
              <SvgIcon icon={ICONS.Garbage} className={styles.delete} />
            </span>
          </Tooltip>
          <span
            className={styles.action}
            onClick={() =>
              this.props.handleToggleActivatedCategoryToUpdate(
                item.id,
                item.label,
                item.associatedAccount
              )
            }
          >
            <i className={classnames("icon icon-arrow-down", styles.rotate)} />
          </span>
        </div>
      </div>
    );
  };

  renderValidateUpdatesActions = (item, type) => {
    return (
      <div
        className={styles.actions}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        {this.props.active && this.props.saving ? (
          <div>
            <span className={styles.action} />
            <span className={styles.action}>
              <img
                src={"/img/icons/tail-spin-green.svg"}
                alt={""}
                className={styles.loading}
              />
            </span>
          </div>
        ) : (
          <div>
            <Tooltip placement="bottom" title={_("return")}>
              <span
                className={styles.action}
                onClick={() => this.props.resetLabels()}
              >
                <img
                  src={"/img/icons/back_arrow.svg"}
                  className={styles.back_arrow}
                  alt={""}
                />
              </span>
            </Tooltip>
            <Tooltip placement="bottom" title={_("save")}>
              <span
                className={styles.action}
                onClick={() => this.props.handleUpdateCategory(type)}
              >
                <img
                  src={"/img/icons/check-mark.svg"}
                  className={styles.check_mark}
                  alt={""}
                />
              </span>
            </Tooltip>
          </div>
        )}
      </div>
    );
  };

  renderNewState = () => {
    const { labelsForm } = this.props;
    return (
      <div
        className={classnames(
          styles.item_category,
          styles.created_state,
          styles.active
        )}
      >
        <div className={styles.item_enabled_status} />
        Nouvelle catégorie
        <LabelsForm
          labels={labelsForm}
          onChangeLabelFormFr={this.props.onChangeLabelFormFr}
          onChangeLabelFormEn={this.props.onChangeLabelFormEn}
          onChangeLabelFormNl={this.props.onChangeLabelFormNl}
        />
      </div>
    );
  };

  render() {
    const { state } = this.props;

    // eslint-disable-next-line default-case
    switch (state) {
      case "STANDARD":
        return this.renderStandardState();
      case "CREATED":
        return this.renderCreatedState();
      case "NEW":
        return this.renderNewState();
    }
  }
}

export default ItemCategory;



// WEBPACK FOOTER //
// ./src/components/AnnexeCategories/ItemCategory.js